import { render, staticRenderFns } from "./cancelReturnsInfoCz.vue?vue&type=template&id=2bb34efe"
import script from "./cancelReturnsInfoCz.vue?vue&type=script&lang=ts"
export * from "./cancelReturnsInfoCz.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports